import React, { useState, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { getUserTransactions } from '../../services/transactionService'
import { formatCurrency, formatDate, formatTransactionType } from '../../utils/formatters'
import { ArrowDownRight, ArrowUpRight } from 'lucide-react'

const TransactionList = () => {
  const { profile } = useAuth()
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadTransactions()
  }, [profile])

  const loadTransactions = async () => {
    if (!profile?.id) return
    const { data } = await getUserTransactions(profile.id, 100)
    if (data) setTransactions(data)
    setLoading(false)
  }

  if (loading) return <div className="flex items-center justify-center h-64"><div className="spinner w-8 h-8" /></div>

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">All Transactions</h1>
      <div className="card">
        {transactions.length === 0 ? (
          <p className="text-center text-gray-500 py-8">No transactions yet</p>
        ) : (
          <div className="space-y-3">
            {transactions.map((transaction) => (
              <div key={transaction.id} className="flex items-center justify-between p-4 rounded-lg bg-gray-50 dark:bg-dark-700">
                <div className="flex items-center gap-4">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    transaction.type === 'deposit' ? 'bg-green-100 dark:bg-green-900/30' : 'bg-red-100 dark:bg-red-900/30'
                  }`}>
                    {transaction.type === 'deposit' ? 
                      <ArrowDownRight className="w-5 h-5 text-green-600" /> : 
                      <ArrowUpRight className="w-5 h-5 text-red-600" />
                    }
                  </div>
                  <div>
                    <p className="font-medium text-gray-900 dark:text-white">{formatTransactionType(transaction.type)}</p>
                    <p className="text-sm text-gray-500">{formatDate(transaction.created_at)}</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className={`font-semibold ${transaction.type === 'deposit' ? 'text-green-600' : 'text-red-600'}`}>
                    {transaction.type === 'deposit' ? '+' : '-'}{formatCurrency(Math.abs(transaction.amount))}
                  </p>
                  <span className={`badge badge-${transaction.status}`}>{transaction.status}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default TransactionList